import { render, staticRenderFns } from "./CostByTag.vue?vue&type=template&id=934b2fdc"
import script from "./CostByTag.vue?vue&type=script&lang=js"
export * from "./CostByTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports